var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('reports-base',{attrs:{"reportsName":"myShop","reportsTitle":"Raport/ Mój Sklep","componentName":"MyShop","resultsPhrase":_vm.resultsPhrase}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }